var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackType31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 55,
    viewBox: "0 0 130 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2054_34095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3604 55C61.1784 55 58.7236 54.7284 55.9961 54.1851C47.6317 52.012 41.2675 47.032 36.9034 39.2451C31.812 41.2371 26.5388 41.6898 21.0838 40.6033C15.4469 39.3356 10.6283 36.4382 6.62789 31.9109C1.71834 26.2971 -0.463679 19.7779 0.0818256 12.3532C0.445496 4.74738 3.44577 -1.50024 9.08266 -6.38968C11.0828 -8.0195 13.2649 -9.92094 15.6287 -12.094C17.8107 -14.4482 20.1746 -16.8024 22.7203 -19.1566C27.0843 -23.5027 31.6302 -27.9395 36.3579 -32.4667C41.2675 -36.994 45.9952 -40.978 50.541 -44.4187C53.6322 -46.7729 56.5416 -48.8554 59.2691 -50.6663C62.1785 -52.4772 64.906 -54.0165 67.4517 -55.2841C76.9071 -59.8114 86.1807 -61.079 95.2724 -59.087C105.637 -56.1896 112.82 -49.5798 116.82 -39.2576C119.366 -32.014 119.275 -24.4082 116.547 -16.4402C116.183 -15.5348 115.82 -14.6293 115.456 -13.7238C115.092 -12.8184 114.638 -11.8224 114.092 -10.7359C120.638 -7.65731 125.366 -2.58678 128.275 4.47575C130.821 11.7194 130.548 18.7819 127.457 25.6633C124.366 32.3637 119.184 36.9815 111.91 39.5167C106.273 41.6898 101.091 43.6818 96.3635 45.4927C91.6358 47.1225 87.6354 48.4807 84.3623 49.5673C82.544 50.2916 80.8166 50.9254 79.1801 51.4687C77.7254 52.012 76.5434 52.4647 75.6343 52.8269C73.8159 53.1891 71.9066 53.6418 69.9065 54.1851C67.9063 54.7284 65.7243 55 63.3604 55Z",
    fill: "#CEFDE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2054_34095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackType31);
export default __webpack_public_path__ + "static/media/back_type3_1.52d1d91bdcb131ff2c83660c5bee8d2b.svg";
export { ForwardRef as ReactComponent };